// extracted by mini-css-extract-plugin
export default {"columnas":"DatosClub_columnas__-T6ry","columnaDoble":"DatosClub_columnaDoble__NvuZc","columnaSimple":"DatosClub_columnaSimple__5z4cq"};